import React from 'react';
import {StarIcon} from "@heroicons/react/24/outline";

export default function RatingIcon(props) {
    const {
        index,
        rating,
        hoverRating,
        onMouseEnter,
        onMouseLeave,
        onSaveRating,
    } = props;
    const fill = React.useMemo(() => {
        if (hoverRating >= index) {
            return 'yellow';
        } else if (!hoverRating && rating >= index) {
            return 'yellow';
        }
        return 'none';
    }, [rating, hoverRating, index]);
    return (
        <div
            className="cursor-pointer flex items-center"
            onMouseEnter={() => onMouseEnter(index)}
            onMouseLeave={() => onMouseLeave()}
            onClick={() => onSaveRating(index)}>
            <StarIcon className="w-6 h-6" fill={fill}/>
        </div>
    )
}